import React, { useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
export const OnScrollWrapper = ({ children, onVisibilityChange, isPartiallyVisible = false, intervalDelay = 100 /* default value */, delayedCall = true, }) => {
    const [isVisible, setIsVisible] = useState(false);
    if (isVisible) {
        onVisibilityChange(isVisible);
    }
    return (React.createElement(VisibilitySensor, { onChange: setIsVisible, partialVisibility: isPartiallyVisible, intervalDelay: intervalDelay, intervalCheck: true, delayedCall: delayedCall }, children));
};
